import { callSideEffects } from './sideEffects';
export function useSelect(sideEffects) {
    function selected(params) {
        callSideEffects(sideEffects, params);
    }
    return [selected];
}
